import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const JoinMeeting = (store) => ({
  path: ROUTE.CLASS_WAITING,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'classWaiting',
    loadReducer: () => import('./ClassWaitingState'),
    loadComponent: () => import('./ClassWaitingContainer'),
  })
})

export default JoinMeeting
